import { ReactNode } from 'react';

import { Box } from 'components/Box';
import { LegacyTooltip } from 'components/LegacyTooltip';

import { ListingPageSectionContainer } from './ListingPageSectionContainer';
import { ListingPageSectionTitle } from './ListingPageSectionTitle';

type Props = {
  title: string;
  tooltip?: string;
  children: ReactNode;
};

export function ListingPageSection({ title, tooltip, children }: Props) {
  return (
    <ListingPageSectionContainer>
      <ListingPageSectionTitle>
        {title}

        {tooltip && (
          <Box ml="6px" display="inline-block" position="relative" top="-3px">
            <LegacyTooltip>{tooltip}</LegacyTooltip>
          </Box>
        )}
      </ListingPageSectionTitle>

      {children}
    </ListingPageSectionContainer>
  );
}
